import { FC, useState } from 'react'
import { useMutation } from 'react-query'
import { useT } from '../../../../../../../_metronic/i18n/Metronici18n'
import { useAuth } from '../../../../../auth'
import { Button } from '../../../../../../components'
import { EstudoDicom } from '../../../../atendimento/core/_models'
import { getPreChecagemEstudoDicom } from '../../../../atendimento/core/_requests'
import { valoresDescricaoEstudo } from './descricaoEstudo'
import {
  ResultadoPreChecagem,
  resultadoDaPreChecagem,
  resultadoDoErroDePreChecagem,
} from './preChecagem'
import styles from './VisualizadorDicom.module.css'

type Props = {
  idAtendimento: number
  estudo: EstudoDicom
  onAbrir: (estudo: EstudoDicom) => void
}

const MENSAGEM: Record<Exclude<ResultadoPreChecagem, 'ok'>, string> = {
  sessao_expirada: 'exames_imagem.viewer.sessao_expirada',
  sem_acesso: 'exames_imagem.viewer.sem_acesso',
  falha: 'exames_imagem.viewer.falha',
}

export const AbrirEstudoDicomBotao: FC<Props> = ({ idAtendimento, estudo, onAbrir }) => {
  const { t } = useT()
  const { auth, currentUser } = useAuth()
  const [resultado, setResultado] = useState<ResultadoPreChecagem | undefined>(undefined)
  const preChecagem = useMutation(() =>
    getPreChecagemEstudoDicom(idAtendimento, estudo.studyInstanceUid)
  )

  const abrir = () => {
    // Sem `disabled` durante a checagem: botão desabilitado perde o foco, e o modal
    // não teria para onde devolvê-lo ao fechar.
    if (preChecagem.isLoading) return
    setResultado(undefined)
    preChecagem.mutate(undefined, {
      onSuccess: (estudos) => {
        const proximo = resultadoDaPreChecagem(estudos)
        if (proximo === 'ok') onAbrir(estudo)
        else setResultado(proximo)
      },
      onError: (erro) => setResultado(resultadoDoErroDePreChecagem(erro)),
    })
  }

  if (!auth?.accessToken || !currentUser) return null

  // Fragmento: na célula da tabela o alerta ocupa a linha inteira, abaixo da miniatura e do botão.
  return (
    <>
      <Button
        variant='tertiary'
        size='btn-sm'
        className={styles.focoVisivel}
        onClick={abrir}
        ariaLabel={t('exames_imagem.viewer.abrir_aria', valoresDescricaoEstudo(estudo, t))}
      >
        {t('exames_imagem.viewer.abrir')}
      </Button>
      {resultado && resultado !== 'ok' && (
        <div role='alert' className={styles.erroAbrir}>
          <span>{t(MENSAGEM[resultado])}</span>
          {resultado === 'falha' && (
            <Button variant='tertiary' size='btn-sm' className={styles.focoVisivel} onClick={abrir}>
              {t('exames_imagem.tentar_novamente')}
            </Button>
          )}
        </div>
      )}
    </>
  )
}
